module.exports = __webpack_public_path__ + "img/3-5.aaa5381f.svg";